export function splitAmountEvenly(amount: number, parts: number): Array<number> {
  if (parts <= 0) return []
  const totalCents = Math.round(amount * 100)
  const baseCents = Math.floor(totalCents / parts)
  const remainderCents = totalCents - baseCents * parts
  return Array.from({ length: parts }, (_, i) =>
    (baseCents + (i < remainderCents ? 1 : 0)) / 100,
  )
}
